import { SceneMetric } from "../../stores/use-reports-scene-store";
import { getSceneInfoModal } from "../../utils/get-scene-info-modal";
import { InfoModalTrigger } from "@/components/ui/modal";

/* Prop Types */
interface SceneMetricHeaderProps {
  metric: SceneMetric;
  onReadMoreClick?: () => void;
}

/**
 * Get the title for a metric
 */
const getMetricTitle = (metric: SceneMetric): string => {
  switch (metric) {
    case "vis":
      return "Visibility";
    case "pop":
      return "Probability of Perception (POP)";
    case "soa":
      return "Share of Attention (SOA)";
    case "pow":
      return "Attention Power Factor (POW)";
    default:
      return "Visibility";
  }
};

/**
 * Get the description for a metric
 */
const getMetricDescription = (metric: SceneMetric): string => {
  switch (metric) {
    case "vis":
      return "How effectively does your AOI element win attention within your scene?";
    case "pop":
      return "Probability of Perception shows percentage of viewers likely to notice the element at first glance.";
    case "soa":
      return "Share of Attention measures attention an element will likely receive within the scene.";
    case "pow":
      return "How effectively does your AOI element utilises given space in the scene?";
    default:
      return "How effectively does your AOI element win attention within your scene?";
  }
};

/*
 * SceneMetricHeader component
 *
 * Displays the header section for a scene metric tab, including title,
 * description, and "Read more" link.
 */
export const SceneMetricHeader = ({ metric, onReadMoreClick }: SceneMetricHeaderProps) => {
  /* Render */
  return (
    <div className="px-4 py-2 my-4">
      <h2 className="font-semibold mb-2">{getMetricTitle(metric)}</h2>
      <p className="text-sm text-base-content/70 mb-2">
        {getMetricDescription(metric)}{" "}
        <InfoModalTrigger modalContent={getSceneInfoModal(metric)} onClick={onReadMoreClick} config={{ className: "w-full max-w-[591px]" }}>
          <span className="underline cursor-pointer">Read more</span>
        </InfoModalTrigger>
      </p>
    </div>
  );
};
